import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "third-login" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "google-login-button",
  "data-track-event": "Login|Sign in with Google clicked ",
  "data-locale": "zh_CN"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3, 512)), [
    [_vShow, _ctx.isInit]
  ])
}